import React from 'react';

import './FormSection.scss';

export default ({ children }) => <div className="vl-form-section">{children}</div>;
